"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ToggleSwitch = exports.ToggledStatus = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var check_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/check.icon.svg"));
var ToggleSwitch_module_scss_1 = __importDefault(require("./ToggleSwitch.module.scss"));
var ToggledStatus;
(function (ToggledStatus) {
    ToggledStatus["ON"] = "on";
    ToggledStatus["OFF"] = "off";
})(ToggledStatus = exports.ToggledStatus || (exports.ToggledStatus = {}));
var ToggleSwitch = function (_a) {
    var toggledStatus = _a.toggledStatus, onToggle = _a.onToggle, reversed = _a.reversed, automationId = _a.automationId, restProps = __rest(_a, ["toggledStatus", "onToggle", "reversed", "automationId"]);
    var isOn = toggledStatus === ToggledStatus.ON;
    return (react_1["default"].createElement("span", { className: (0, classnames_1["default"])(isOn ? ToggleSwitch_module_scss_1["default"].on : ToggleSwitch_module_scss_1["default"].off, reversed && ToggleSwitch_module_scss_1["default"].reversed) },
        react_1["default"].createElement("input", __assign({ type: "checkbox", "data-automation-id": automationId, className: ToggleSwitch_module_scss_1["default"].checkbox, checked: isOn ? true : false, onChange: onToggle }, restProps)),
        react_1["default"].createElement("span", { className: ToggleSwitch_module_scss_1["default"].track },
            react_1["default"].createElement("span", { className: ToggleSwitch_module_scss_1["default"].thumb },
                react_1["default"].createElement(component_library_1.Icon, { icon: check_icon_svg_1["default"], classNameOverride: ToggleSwitch_module_scss_1["default"].checkIcon, role: "presentation" })))));
};
exports.ToggleSwitch = ToggleSwitch;
exports.ToggleSwitch.displayName = "ToggleSwitch";
//# sourceMappingURL=ToggleSwitch.js.map